<template>
  <div class="mb-4" :style="{minHeight: photos.length === 0 ? '300px' : 'auto'}">
    <ViewLoader v-if="loading"/>
    <template v-else>
      <template v-if="photos.length > 0">
        <div class="collage-photo__group-title">
          <h6 class="font-weight-medium">{{ $t('pages.checkins_detail.my_photos') }}</h6>
        </div>
        <div class="row collage-photo">
          <CollagePhotoItemBought
              v-for="(photo, index) in photos"
              :key="index"
              :photo="photo"
              :is-unlocked="true"
              :has-photo-original="checkin.pica_service.has_media_original"
              :dt-photos-hd-available-formatted="checkin.pica_service.hd_available_from|formatDate"
              @zoom-clicked="showGallery(index)"/>
        </div>
      </template>

      <template v-else>
        <div v-if="!loading && !eventClosed">
          <CtaSupport :event-name="eventName" :pica-code="picaCode" v-if="isPromo"/>
          <template v-else>
             <CtaNoPhotosBought :event-name="eventName" :pica-code="picaCode" v-if="!videoOnlySale"/>
          </template>

        </div>
      </template>

      <ModalPhotoGalleryBought ref="modalPhotoGalleryBought"
                               :checkin-id="checkin.checkin_id"
                               :photos="photos"
                               :event-name="checkin.pica_service.event_name"
                               :event-date="checkin.pica_service.event_start_at"
                               :share-mode="checkin.pica_service.share_mode"
                               :has-pica-service-photo-original="checkin.pica_service.has_media_original"
                               :dt-photos-hd-available-formatted="checkin.pica_service.hd_available_from|formatDate"
                               :picacode="checkin.picacode"
                               @media-removed="$emit('media-removed', $event)"/>

    </template>
  </div>
</template>


<script>
import CollagePhotoItemBought from '@/components/CollagePhotoItemBought'
import ModalPhotoGalleryBought from '@/components/ModalPhotoGalleryBought'
import ViewLoader from "@/components/ViewLoader.vue";
import CtaSupport from "@/domain/checkinDetail/cta/CtaSupport.vue";
import {mapGetters} from "vuex";
import CtaNoPhotosBought from "@/domain/checkinDetail/cta/CtaNoPhotosBought.vue";

export default {
  components: {
    CtaNoPhotosBought,
    CtaSupport,
    ViewLoader,
    CollagePhotoItemBought,
    ModalPhotoGalleryBought
  },

  // TODO: eliminare photos e prendere direttamente checkin.bought_photos
  props: ['checkin', 'photos', 'isPromo', 'eventClosed', 'loading'],

  computed: {
    ...mapGetters('checkinDetail', ['eventName', 'picaCode']),
    videoOnlySale() {
      return this.checkin.price_list && this.checkin.price_list.videos_only_sale
    },
  },

  methods: {
    showGallery(index) {
      this.$refs.modalPhotoGalleryBought.show(index)
    },
  }
}
</script>
